/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../../js/global.js";
	import * as helper from "../../../js/helper.js";
	import full_loading from "../../components/full-loading.vue";
	import property_component from "../../components/property-component.vue";
	import filter_tablets_component from "../../components/filter-tablets-component.vue";
	import search_filters_modal from "../../modal/search-filters-modal.vue";
	import transfer_property_modal from "../../modal/transfer-property-modal.vue";
    import VueSelect from '../../../js/vue-select.js';

	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            property_component:property_component,
            filter_tablets_component:filter_tablets_component,
            vue_select:VueSelect,
            search_filters_modal:search_filters_modal,
            transfer_property_modal:transfer_property_modal,
        },
		name:'my_properties_widget',
        props: {
        },
		data() {
			return {
                global,
                helper,
                frappe,
                search_filters: global.search_filters,
                // search_filters:localStorage.my_properties_search_filters?JSON.parse(localStorage.my_properties_search_filters):global.search_filters,
                is_ready:false,
                is_loading:false,
				properties: [],
                page:0,
                end_of_page:false,
			}
		},
        mounted(){
            global.emitter.on("load-search-again", args => {
                this.load_data(true);
            });
            if(!helper.isPageNew()){
                this.check_local_storage();
            }else{
                this.load_data(true);
            }
            window.addEventListener("scroll",this.handleScroll);
        },
        unmounted(){
            window.removeEventListener("scroll",this.handleScroll);
        },
		methods: {
            check_local_storage: async function(){
                this.page = await localStorage.my_properties_page?localStorage.my_properties_page:0;
                this.end_of_page = localStorage.my_properties_end_of_page == 1?true:false;
                this.properties = localStorage.my_properties_records?JSON.parse(localStorage.my_properties_records):[];
                this.$forceUpdate(); 
            },
            load_data: async function(reload=false){
                if(this.is_loading)
                    return;
                if(reload){
                    this.page = 0;
                    this.end_of_page = false;
                    while(this.properties.length > 0) {
                        this.properties.pop();
                    }
                }
                if(this.end_of_page)
                    return;
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                let params = {
                    "filters":JSON.stringify(this.search_filters),
                    "page":this.page
                };
                let url = "/api/method/maalek.api.my_properties";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                if(res.message.length > 0){
                    for (let index = 0; index < res.message.length; index++) {
                        this.properties.push(res.message[index]);
                    }
                    this.page++;
                }else{
                    this.end_of_page = 1;
                }
                localStorage.my_properties_records = JSON.stringify(this.properties);
                localStorage.my_properties_search_filters = JSON.stringify(this.search_filters);
                localStorage.my_properties_page = this.page;
                localStorage.my_properties_end_of_page = this.end_of_page?1:0;
                this.is_loading = false;
                global.emitter.emit("refresh-tooltips");
                global.emitter.emit("hide-full-loading");
                this.is_ready = true;
            },
            handleScroll: function (){
                if(this.end_of_page){
                    window.removeEventListener("scroll",this.handleScroll);
                }
                if(this.loading || this.end_of_page)
                    return;
                let pagination_component = this.$refs["pagination_component"];
                if (pagination_component.getBoundingClientRect().bottom < window.innerHeight) {
                    this.load_data();
                }
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-listing" },
    [
      _c("full_loading"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mb-4" },
        [
          _c(
            "div",
            {
              staticClass: "btn-group border-radius search-group me-2 me-auto",
              attrs: { role: "group" }
            },
            [
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search_filters.search_type,
                        expression: "search_filters.search_type"
                      }
                    ],
                    staticClass: "form-select",
                    staticStyle: { padding: "0 5px", border: "none" },
                    attrs: { "aria-label": "Default select example" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.search_filters,
                            "search_type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function($event) {
                          _vm.search_filters.search_str
                            ? _vm.load_data(true)
                            : null
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "Property Id" } }, [
                      _vm._v(_vm._s(_vm.helper.t("Property Id")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Advertisement Id" } }, [
                      _vm._v(_vm._s(_vm.helper.t("Advertisement Id")))
                    ]),
                    _vm._v(" "),
                    _vm.frappe.user_roles.includes("Agency")
                      ? _c("option", { attrs: { value: "Member Name" } }, [
                          _vm._v(_vm._s(_vm.helper.t("Member Name")))
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search_filters.search_str,
                      expression: "search_filters.search_str"
                    }
                  ],
                  staticClass: "form-control search-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.search_filters.search_str },
                  on: {
                    change: function($event) {
                      return _vm.load_data(true)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.search_filters,
                        "search_str",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c("filter_tablets_component", {
            attrs: { search_filters_prop: _vm.search_filters }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-toolbar",
              attrs: {
                role: "toolbar",
                "aria-label": "Toolbar with button groups"
              }
            },
            [
              _c(
                "div",
                { staticClass: "btn-group me-2", attrs: { role: "group" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.liked == 0
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.liked = 0
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("All")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.liked == 1
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: _vm.helper.t("Stared"),
                        "data-bs-trigger": "hover"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.liked = 1
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa-solid fa-star" })]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.frappe.user_roles.includes("Agency")
                ? _c(
                    "div",
                    { staticClass: "btn-group me-2", attrs: { role: "group" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          class:
                            _vm.search_filters.managed == -1
                              ? "btn-primary"
                              : "btn-outline-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.search_filters.managed = -1
                              _vm.load_data(true)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.helper.t("All")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          class:
                            _vm.search_filters.managed == 0
                              ? "btn-primary"
                              : "btn-outline-secondary",
                          attrs: {
                            type: "button",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: _vm.helper.t("Not Managed"),
                            "data-bs-trigger": "hover"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return function() {
                                if (
                                  _vm.search_filters.search_type ==
                                  "Member Name"
                                ) {
                                  _vm.search_filters.search_str = null
                                }
                                _vm.search_filters.managed = 0
                                _vm.load_data(true)
                              }.apply(null, arguments)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa-solid fa-server" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          class:
                            _vm.search_filters.managed == 1
                              ? "btn-primary"
                              : "btn-outline-secondary",
                          attrs: {
                            type: "button",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: _vm.helper.t("Managed"),
                            "data-bs-trigger": "hover"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.search_filters.managed = 1
                              _vm.load_data(true)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa-solid fa-briefcase" })]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-group me-2", attrs: { role: "group" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.locked == -1
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.locked = -1
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("All")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.locked == 0
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: _vm.helper.t("Not Locked"),
                        "data-bs-trigger": "hover"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.locked = 0
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa-solid fa-lock-open" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.locked == 1
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: _vm.helper.t("Locked"),
                        "data-bs-trigger": "hover"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.locked = 1
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa-solid fa-lock" })]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-group me-2", attrs: { role: "group" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.published == -1
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.published = -1
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("All")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.published == 1
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: _vm.helper.t("Published"),
                        "data-bs-trigger": "hover"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.published = 1
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa-solid fa-circle-check" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class:
                        _vm.search_filters.published == 0
                          ? "btn-primary"
                          : "btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: _vm.helper.t("Unpublished"),
                        "data-bs-trigger": "hover"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.search_filters.published = 0
                          _vm.load_data(true)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa-solid fa-circle-xmark" })]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-group",
                  attrs: { role: "group", "aria-label": "Third group" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#searchFiltersModal"
                      }
                    },
                    [
                      _c("i", { staticClass: "fa-solid fa-sliders" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.helper.t("More Filters")) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "pagination_component", staticClass: "row g-3" },
        [
          _vm._l(_vm.properties, function(property) {
            return _c(
              "div",
              { staticClass: "col-lg-4 col-xl-3" },
              [_c("property_component", { attrs: { property: property } })],
              1
            )
          }),
          _vm._v(" "),
          !_vm.is_loading && _vm.is_ready && _vm.properties.length == 0
            ? _c("h5", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.helper.t("No property to show!")))
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("search_filters_modal", {
        attrs: {
          for_map_search: false,
          search_filters_prop: _vm.search_filters
        }
      }),
      _vm._v(" "),
      _c("transfer_property_modal")
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4b8e782b_0", { source: "\n.search-group{\r\n    border: SOLID 1px;\r\n    padding: 1px;\r\n    border-color: #014116;\n}\n.search-group *{\r\n    font-size: small;\n}\n.search-control{\r\n    padding: 0 5px;\r\n    height: 34px;\n}\r\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/account/my-properties-widget.vue"],"names":[],"mappings":";AAuNA;IACA,iBAAA;IACA,YAAA;IACA,qBAAA;AACA;AACA;IACA,gBAAA;AACA;AACA;IACA,cAAA;IACA,YAAA;AACA","file":"my-properties-widget.vue","sourcesContent":["<template>\r\n    <div class=\"my-listing\">\r\n        <full_loading></full_loading>\r\n        <div class=\"d-flex justify-content-end mb-4\">\r\n            <div class=\"btn-group border-radius search-group me-2 me-auto\" role=\"group\">\r\n                <div class=\"input-group\">\r\n                    <select v-model=\"search_filters.search_type\" class=\"form-select\" aria-label=\"Default select example\" style=\"padding: 0 5px; border: none;\" @change=\"search_filters.search_str?load_data(true):null\">\r\n                        <option value=\"Property Id\">{{ helper.t(\"Property Id\") }}</option>\r\n                        <option value=\"Advertisement Id\">{{ helper.t(\"Advertisement Id\") }}</option>\r\n                        <option v-if=\"frappe.user_roles.includes('Agency')\" value=\"Member Name\">{{ helper.t(\"Member Name\") }}</option>\r\n                    </select>\r\n                    <input type=\"text\" class=\"form-control search-control\" v-model=\"search_filters.search_str\" @change=\"load_data(true);\" />\r\n                </div>\r\n            </div>\r\n            <filter_tablets_component\r\n                :search_filters_prop=\"search_filters\">\r\n            </filter_tablets_component>\r\n            <div class=\"btn-toolbar\" role=\"toolbar\" aria-label=\"Toolbar with button groups\">\r\n                <div class=\"btn-group me-2\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.liked=0;load_data(true);\"\r\n                        :class=\"search_filters.liked==0?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"All\") }}</button>\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.liked=1;load_data(true);\"\r\n                        data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Stared')\" data-bs-trigger=\"hover\"\r\n                        :class=\"search_filters.liked==1?'btn-primary':'btn-outline-secondary'\"><i class=\"fa-solid fa-star\"></i></button>\r\n                </div>\r\n                <div v-if=\"frappe.user_roles.includes('Agency')\" class=\"btn-group me-2\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.managed=-1;load_data(true);\"\r\n                        :class=\"search_filters.managed==-1?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"All\") }}</button>\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"()=>{\r\n                            if(search_filters.search_type == 'Member Name'){\r\n                                search_filters.search_str = null;\r\n                            }\r\n                            search_filters.managed=0;\r\n                            load_data(true);\r\n                        }\"\r\n                        data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Not Managed')\" data-bs-trigger=\"hover\"\r\n                        :class=\"search_filters.managed==0?'btn-primary':'btn-outline-secondary'\"><i class=\"fa-solid fa-server\"></i></button>\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.managed=1;load_data(true);\"\r\n                        data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Managed')\" data-bs-trigger=\"hover\"\r\n                        :class=\"search_filters.managed==1?'btn-primary':'btn-outline-secondary'\"><i class=\"fa-solid fa-briefcase\"></i></button> \r\n                </div>\r\n                <div class=\"btn-group me-2\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.locked=-1;load_data(true);\"\r\n                        :class=\"search_filters.locked==-1?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"All\") }}</button>\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.locked=0;load_data(true);\"\r\n                        data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Not Locked')\" data-bs-trigger=\"hover\"\r\n                        :class=\"search_filters.locked==0?'btn-primary':'btn-outline-secondary'\"><i class=\"fa-solid fa-lock-open\"></i></button>\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.locked=1;load_data(true);\"\r\n                        data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Locked')\" data-bs-trigger=\"hover\"\r\n                        :class=\"search_filters.locked==1?'btn-primary':'btn-outline-secondary'\"><i class=\"fa-solid fa-lock\"></i></button>\r\n                </div>\r\n                <div class=\"btn-group me-2\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.published=-1;load_data(true);\"\r\n                        :class=\"search_filters.published==-1?'btn-primary':'btn-outline-secondary'\">{{ helper.t(\"All\") }}</button>\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.published=1;load_data(true);\"\r\n                        data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Published')\" data-bs-trigger=\"hover\"\r\n                        :class=\"search_filters.published==1?'btn-primary':'btn-outline-secondary'\"><i class=\"fa-solid fa-circle-check\"></i></button>\r\n                    <button type=\"button\" class=\"btn\"\r\n                        @click.prevent=\"search_filters.published=0;load_data(true);\"\r\n                        data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Unpublished')\" data-bs-trigger=\"hover\"\r\n                        :class=\"search_filters.published==0?'btn-primary':'btn-outline-secondary'\"><i class=\"fa-solid fa-circle-xmark\"></i></button>\r\n                </div>\r\n                <div class=\"btn-group\" role=\"group\" aria-label=\"Third group\">\r\n                    <button type=\"button\" class=\"btn btn-outline-secondary\" data-bs-toggle=\"modal\" data-bs-target=\"#searchFiltersModal\">\r\n                        <i class=\"fa-solid fa-sliders\"></i> {{ helper.t(\"More Filters\") }}\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"row g-3\" ref=\"pagination_component\">\r\n            <div v-for=\"property in properties\" class=\"col-lg-4 col-xl-3\">\r\n                <property_component\r\n                    :property=\"property\"\r\n                ></property_component>\r\n            </div>\r\n            <h5 v-if=\"!is_loading && is_ready && properties.length == 0\" class=\"text-center\">{{ helper.t(\"No property to show!\") }}</h5>\r\n        </div>\r\n        <!-- Modal -->\r\n        <search_filters_modal\r\n            :for_map_search=\"false\"\r\n            :search_filters_prop=\"search_filters\"\r\n        ></search_filters_modal>\r\n        <!-- Modal -->\r\n        <!-- Modal -->\r\n        <transfer_property_modal></transfer_property_modal>\r\n        <!-- Modal -->\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n\timport * as global from \"../../../js/global.js\";\r\n\timport * as helper from \"../../../js/helper.js\";\r\n\timport full_loading from \"../../components/full-loading.vue\";\r\n\timport property_component from \"../../components/property-component.vue\";\r\n\timport filter_tablets_component from \"../../components/filter-tablets-component.vue\";\r\n\timport search_filters_modal from \"../../modal/search-filters-modal.vue\";\r\n\timport transfer_property_modal from \"../../modal/transfer-property-modal.vue\";\r\n    import VueSelect from '../../../js/vue-select.js';\r\n\r\n\texport default{\r\n        components: {\r\n            full_loading:full_loading,\r\n            property_component:property_component,\r\n            filter_tablets_component:filter_tablets_component,\r\n            vue_select:VueSelect,\r\n            search_filters_modal:search_filters_modal,\r\n            transfer_property_modal:transfer_property_modal,\r\n        },\r\n\t\tname:'my_properties_widget',\r\n        props: {\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                search_filters: global.search_filters,\r\n                // search_filters:localStorage.my_properties_search_filters?JSON.parse(localStorage.my_properties_search_filters):global.search_filters,\r\n                is_ready:false,\r\n                is_loading:false,\r\n\t\t\t\tproperties: [],\r\n                page:0,\r\n                end_of_page:false,\r\n\t\t\t}\r\n\t\t},\r\n        mounted(){\r\n            global.emitter.on(\"load-search-again\", args => {\r\n                this.load_data(true);\r\n            });\r\n            if(!helper.isPageNew()){\r\n                this.check_local_storage();\r\n            }else{\r\n                this.load_data(true);\r\n            }\r\n            window.addEventListener(\"scroll\",this.handleScroll);\r\n        },\r\n        unmounted(){\r\n            window.removeEventListener(\"scroll\",this.handleScroll);\r\n        },\r\n\t\tmethods: {\r\n            check_local_storage: async function(){\r\n                this.page = await localStorage.my_properties_page?localStorage.my_properties_page:0;\r\n                this.end_of_page = localStorage.my_properties_end_of_page == 1?true:false;\r\n                this.properties = localStorage.my_properties_records?JSON.parse(localStorage.my_properties_records):[];\r\n                this.$forceUpdate(); \r\n            },\r\n            load_data: async function(reload=false){\r\n                if(this.is_loading)\r\n                    return;\r\n                if(reload){\r\n                    this.page = 0;\r\n                    this.end_of_page = false;\r\n                    while(this.properties.length > 0) {\r\n                        this.properties.pop();\r\n                    }\r\n                }\r\n                if(this.end_of_page)\r\n                    return;\r\n                global.emitter.emit(\"show-full-loading\");\r\n                this.is_loading = true;\r\n                let params = {\r\n                    \"filters\":JSON.stringify(this.search_filters),\r\n                    \"page\":this.page\r\n                };\r\n                let url = \"/api/method/maalek.api.my_properties\";\r\n                let res = await $.ajax({\r\n                    url: url,\r\n                    type: \"GET\",\r\n                    data: params\r\n                });\r\n                if(res.message.length > 0){\r\n                    for (let index = 0; index < res.message.length; index++) {\r\n                        this.properties.push(res.message[index]);\r\n                    }\r\n                    this.page++;\r\n                }else{\r\n                    this.end_of_page = 1;\r\n                }\r\n                localStorage.my_properties_records = JSON.stringify(this.properties);\r\n                localStorage.my_properties_search_filters = JSON.stringify(this.search_filters);\r\n                localStorage.my_properties_page = this.page;\r\n                localStorage.my_properties_end_of_page = this.end_of_page?1:0;\r\n                this.is_loading = false;\r\n                global.emitter.emit(\"refresh-tooltips\");\r\n                global.emitter.emit(\"hide-full-loading\");\r\n                this.is_ready = true;\r\n            },\r\n            handleScroll: function (){\r\n                if(this.end_of_page){\r\n                    window.removeEventListener(\"scroll\",this.handleScroll);\r\n                }\r\n                if(this.loading || this.end_of_page)\r\n                    return;\r\n                let pagination_component = this.$refs[\"pagination_component\"];\r\n                if (pagination_component.getBoundingClientRect().bottom < window.innerHeight) {\r\n                    this.load_data();\r\n                }\r\n            }\r\n\t\t},\r\n\t\tcomputed:{\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n.search-group{\r\n    border: SOLID 1px;\r\n    padding: 1px;\r\n    border-color: #014116;\r\n}\r\n.search-group *{\r\n    font-size: small;\r\n}\r\n.search-control{\r\n    padding: 0 5px;\r\n    height: 34px;\r\n}\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/my-properties-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__